import {Injectable} from "@angular/core";
import {ModalService} from "n-framework/n-modal";
import {PromptModalOptions} from "./components/n-prompt-modal/n-prompt-modal.component";
import {NPromptModalComponent} from "./components/public_components";

@Injectable({providedIn: "root"})
export class PromptModalService {
  constructor(private modalService: ModalService) {
  }

  confirm<T = boolean>(options: PromptModalOptions): Promise<T> {
    return this.modalService.open<T>(NPromptModalComponent, {
      windowTheme: "dialog",
      escape: true
    }, options).result;
  }

  inputConfirm(options: PromptModalOptions): Promise<string> {
    return this.modalService.open<string>(NPromptModalComponent, {
      windowTheme: "dialog",
      escape: true
    }, options).result;
  }

}
